import { breakpoints } from '@/themes/themeOverrides/Breakpoints';
import { Palette } from '@/themes/themeOverrides/Palette';

export const RaSidebarStyles = {
    styleOverrides: {
        root: {
            backgroundColor: Palette.white,
            borderRight: `2px solid ${Palette.gray.gray100}`,
            height: 'auto',
            flexShrink: '0',
            '& .MuiList-root.MuiList-padding.RaMenu-open': {
                width: '100%',
                padding: '15px 11px',
                [`@media (min-width: ${breakpoints.values.sm}px)`]: {
                    padding: '0',
                },
                [`@media (min-width: ${breakpoints.values.md}px)`]: {
                    width: '238px',
                },
            },
            '& .MuiPaper-elevation': {
                width: '100%',
                height: '100%',
                '& .toggle-menu-button': {
                    padding: 0,
                    lineHeight: '48px !important',
                    minWidth: 10,
                    display: 'block',
                    position: 'static',
                    maxWidth: '100%',
                    marginTop: '20px',
                },
            },
            '& .menu-item': {
                '& .menu-primary': {
                    cursor: 'pointer',
                    padding: '20px 16px',
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'nowrap',
                    borderRadius: '16px',
                    fontWeight: 600,
                    '&:hover': {
                        backgroundColor: Palette.yellow.yellow50,
                    },
                    '& span': {
                        padding: '0 15px',
                        fontSize: '16px',
                        lineHeight: '22px',
                    },
                    '& svg': {
                        minWidth: '24px',
                    },
                    '& svg:last-child': {
                        alignSelf: 'flex-end',
                        marginLeft: 'auto',
                        position: 'relative',
                        top: '-2px',
                    },
                },
                '& .menu-secondary': {
                    paddingBottom: '12px',
                    paddingTop: '1px',
                    '& a.MuiMenuItem-root': {
                        fontSize: '14px',
                        lineHeight: '20px',
                        borderRadius: '12px',
                        fontWeight: 400,
                        padding: '12px 20px',
                        margin: '4px 0',
                        whiteSpace: 'normal',
                        '&:hover': {
                            backgroundColor: Palette.gray.gray100,
                        },
                        '& svg': {
                            minWidth: '16px',
                        },
                    },
                },
            },
            '& .RaSidebar-fixed': {
                position: 'relative !important',
                width: '100%',
                padding: '15px 11px',
                paddingBottom: 80,
                height: '100%',
                backgroundColor: Palette.white,
                [`@media (min-width: ${breakpoints.values.lg}px)`]: {
                    '& .RaMenu-closed': {
                        width: 60,
                        '& .menu-primary': {
                            '& span': {
                                display: 'none',
                                '& + svg': {
                                    display: 'none',
                                },
                            },
                        },
                        '& .menu-secondary': {
                            '& a.MuiMenuItem-root': {
                                width: '55px',
                                overflow: 'hidden',
                            },
                        },
                    },
                },
            },
            [`@media (min-width: ${breakpoints.values.lg}px)`]: {
                '& .RaMenu-closed': {
                    width: 60,

                    '& .MuiMenuItem-root': {
                        fontSize: 0,
                    },
                    '& + .toggle-menu-button': {
                        '& svg': {
                            transform: 'rotate(180deg)',
                        },
                    },
                },
            },
            '& .MuiMenuItem-root': {
                borderRadius: 12,
                backgroundColor: Palette.white,
                color: Palette.black,
                padding: 16,
                fontSize: 16,
                fontWeight: 600,
                lineHeight: 2,
                '&:hover, &.RaMenuItemLink-active': {
                    backgroundColor: Palette.gray.gray100,
                },
                '& .RaMenuItemLink-icon': {
                    marginRight: 16,
                },
            },
        },
    },
};
